<script setup>
const props = defineProps({
  value: [String, Number],
  text: String,
  needIcon: {
    type: Boolean,
    default: true,
  },
})
const message = useMessage()
const { t } = useI18n()

function copy() {
  if (!props.value) {
    return
  }
  const textarea = document.createElement('textarea')
  textarea.style.position = 'fixed'
  textarea.style.top = '-9999px'
  textarea.style.left = '-9999px'
  textarea.style.zIndex = '9999999999999'
  textarea.value = props.value
  textarea.setAttribute('readonly', 'true')
  document.body.append(textarea)
  textarea.select() // 选中值并复制
  const res = textarea.value && document.execCommand('Copy')
  if (res && textarea.value && textarea.value !== '--') {
    message.success(props.text || t('复制成功'))
  }
  document.body.removeChild(textarea)
}
</script>

<template>
  <div class="inline-flex cursor-pointer" @click="copy">
    <slot />
    <slot v-if="needIcon" name="icon">
      <svgo-common-copy2 class="w-4 h-4" :class="$attrs.iconClass" />
    </slot>
  </div>
</template>
